import request from '@/utils/request'

// 查询建设单位管理费总额控制数费率列表
export function listRate(query) {
  return request({
    url: '/project/rate/list',
    method: 'get',
    params: query
  })
}

// 查询建设单位管理费总额控制数费率详细
export function getRate(id) {
  return request({
    url: '/project/rate/' + id,
    method: 'get'
  })
}

// 新增建设单位管理费总额控制数费率
export function addRate(data) {
  return request({
    url: '/project/rate',
    method: 'post',
    data: data
  })
}

// 修改建设单位管理费总额控制数费率
export function updateRate(data) {
  return request({
    url: '/project/rate',
    method: 'put',
    data: data
  })
}

// 删除建设单位管理费总额控制数费率
export function delRate(id) {
  return request({
    url: '/project/rate/' + id,
    method: 'delete'
  })
}
